( function ( _s ) {
	/** Check if keyup event key is ENTER */

	window.isEventKeyEnter = e => {
		return (
			( e.type === 'keyup' || e.type === 'keydown' || e.type === 'keypress' ) &&
			( e.key === 'Enter' || e.code === 'Enter' || e.code === 'NumpadEnter' )
		);
	};

	/** Body click */
	_s( 'body' ).on( 'click', e => {
		_s( window ).trigger( 'fr:body-click', {
			event: e,
		} );
	} );
} )( window._s );
